// extracted by mini-css-extract-plugin
export var container = "_se-0";
export var dotAnimation = "_se-2";
export var dotsLoading = "_se-1";